import { TTypeOfCodec } from "../../../shared/src/codecs/codec";
import { array } from "../../../shared/src/codecs/types/array";
import { boolean } from "../../../shared/src/codecs/types/boolean";
import { date } from "../../../shared/src/codecs/types/date";
import { dateTime } from "../../../shared/src/codecs/types/dateTime";
import { form } from "../../../shared/src/codecs/types/form";
import { literal } from "../../../shared/src/codecs/types/literal";
import { nullCodec } from "../../../shared/src/codecs/types/nullCodec";
import { positiveInteger } from "../../../shared/src/codecs/types/positiveInteger";
import { required } from "../../../shared/src/codecs/types/required";
import { string } from "../../../shared/src/codecs/types/string";
import { union } from "../../../shared/src/codecs/types/union";
import { uuid } from "../../../shared/src/codecs/types/uuid";
import { PlainUser } from "../User";
import { AddressFirstLines } from "../overloads/AddressFirstLine";
import { requiredFlatOverloaded } from "../../../shared/src/codecs/types/requiredFlatOverloaded";
import { intersection } from "../../../shared/src/codecs/types/intersection";
import { RoadblockAwaitableEntity, RoadblockChecklistItemType, RoadblockStatus, RoadblockType } from "./RoadblockForm";
import { DayWorkSource } from "../DayWorkSource";
import { DaySortKey } from "../DaySortKey";

export const RoadblockDayViewNextItem = required({
    type: RoadblockChecklistItemType,
    display_name: string(),
});
export type TRoadblockDayViewNextItemCodec = typeof RoadblockDayViewNextItem;
export type TRoadblockDayViewNextItem = TTypeOfCodec<TRoadblockDayViewNextItemCodec>;

export const RoadblockDayViewListItem = intersection([
    required({
        id: uuid(),
        case_id: uuid(),
        roadblock_type: RoadblockType,
        status: RoadblockStatus,
        sla: dateTime(),
        blocked_till: union([dateTime(), nullCodec()]),
        blocked_waiting_on: union([string(), nullCodec()]),
        blocked_waiting_on_is_internal: boolean(),
        next_item: union([RoadblockDayViewNextItem, nullCodec()]),
        unresolved_count: positiveInteger(),
        assigned_to_user: PlainUser,
        case_in_chase: boolean(),
        is_under_offer: boolean(),
        sort_rank: positiveInteger(),
    }),
    requiredFlatOverloaded({
        address: AddressFirstLines,
    }),
]);
export type TRoadblockDayViewListItemCodec = typeof RoadblockDayViewListItem;
export type TRoadblockDayViewListItem = TTypeOfCodec<TRoadblockDayViewListItemCodec>;

export const CasesDayViewRoadblocksForm = form(
    required({
        filters: required({
            date: union([
                required({
                    type: literal("iso"),
                    date: date(),
                }),
                required({
                    type: literal("overdue"),
                }),
            ]),
            assigned_to: union([nullCodec(), uuid()]),
            roadblock_type: union([nullCodec(), RoadblockType]),
            roadblock_checklist_item_type: union([nullCodec(), RoadblockChecklistItemType]),
            sail_homes_listing_only: boolean(),
            source: DayWorkSource,
            sort: DaySortKey,
        }),
        pagination: required({
            offset: positiveInteger(),
            limit: positiveInteger(),
        }),
    }),
    required({
        roadblocks: array(RoadblockDayViewListItem),
        overdue_count: positiveInteger(),
        available_count: positiveInteger(),
        outstanding_today_count: positiveInteger(),
        resolved_today_count: positiveInteger(),
        awaitable_entities: array(RoadblockAwaitableEntity),
        parked_roadblocks: array(RoadblockDayViewListItem),
    }),
);
export type TCasesDayViewRoadblocksFormCodec = typeof CasesDayViewRoadblocksForm;
export type TCasesDayViewRoadblocksForm = TTypeOfCodec<TCasesDayViewRoadblocksFormCodec>;

